import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Book, Camera, Cpu } from 'lucide-react';

export default function AddAssignment() {
  const navigate = useNavigate();

  const handleUploadPDF = () => {
    navigate('/assignments/upload-pdf');
  };

  const handleMakeFromBook = () => {
    navigate('/assignments/make-from-book');
  };

  const handleClickPhoto = () => {
    alert('Opening camera for clicking photos');
  };

  const handleCreateWithAI = () => {
    navigate('/assignments/createWithAI');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6 font-sans">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 text-center mb-2">Create an Assignment</h1>
        <p className="text-xl text-gray-600 text-center mb-12">Select an assignment type below to get started.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <AssignmentCard
            icon={<FileText size={48} />}
            title="Upload Doc"
            description="Upload a Doc file containing the assignment details and questions."
            onClick={handleUploadPDF}
          />

          <AssignmentCard
            icon={<Camera size={48} />}
            title="Click Photo"
            description="Take a photo of a physical assignment sheet to create a digital version."
            onClick={handleClickPhoto}
          />

          <AssignmentCard
            icon={<Cpu size={48} />}
            title="Create with AI"
            description="Use AI to generate custom assignments based on your specifications."
            onClick={handleCreateWithAI}
          />
        </div>
      </div>
    </div>
  );
}

function AssignmentCard({ icon, title, description, onClick }) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
      <div className="bg-blue-100 rounded-full p-4 mb-4">
        {React.cloneElement(icon, { className: "text-blue-500" })}
      </div>
      <h2 className="text-xl font-semibold text-gray-800 mb-3">{title}</h2>
      <p className="text-gray-600 text-center mb-6 flex-grow">{description}</p>
      <button
        onClick={onClick}
        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300 font-medium"
      >
        Select
      </button>
    </div>
  );
}

